/**
 * Equal Height elements by group
 * @usage [data-equal-height="groupName"]
 */
export default function equalHeights(domNode = document) {
	const elements = domNode.querySelectorAll('[data-equal-height]');

	if (window.od.device() !== 'lg' || !elements.length) return;

	const groupElements = array =>
		array.reduce((obj, el) => {
			const value = el.getAttribute('data-equal-height');
			(obj[value] =
				Object.keys(obj).indexOf(value) > -1 ? obj[value] : []).push(el);
			return obj;
		}, {});

	const getMaxHeight = group =>
		group.reduce(
			(max, el) => (el.offsetHeight > max ? el.offsetHeight : max),
			0,
		);

	const equalHeight = group => {
		const maxHeight = getMaxHeight(group);

		group.forEach(el => {
			if (el.offsetHeight !== maxHeight) {
				el.style.height = `${maxHeight}px`;
			}
		});
	};

	const groups = groupElements(Array.from(elements));
	const groupsArray = Object.keys(groups).map(group => groups[group]);
	groupsArray.forEach(equalHeight);
}
